/**
 * @generated SignedSource<<4599a0c44719a859e67dde8dbfa2b691>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DrawingSetStatusInput = "DRAFT" | "PUBLISHED" | "%future added value";
export type DrawingSetVersionChangeStatusInput = {
  drawingSetVersionId: string;
  status: DrawingSetStatusInput;
};
export type drawingSetVersionChangeStatusMutation$variables = {
  input: DrawingSetVersionChangeStatusInput;
};
export type drawingSetVersionChangeStatusMutation$data = {
  readonly drawingSetVersionChangeStatus: {
    readonly " $fragmentSpreads": FragmentRefs<"drawingSetVersionFragment">;
  };
};
export type drawingSetVersionChangeStatusMutation = {
  response: drawingSetVersionChangeStatusMutation$data;
  variables: drawingSetVersionChangeStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "drawingSetVersionChangeStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetVersion",
        "kind": "LinkedField",
        "name": "drawingSetVersionChangeStatus",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "drawingSetVersionFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "drawingSetVersionChangeStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetVersion",
        "kind": "LinkedField",
        "name": "drawingSetVersionChangeStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "versionDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "drawingSetId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7c2cb834e862f861fe64ae43237bfb43",
    "id": null,
    "metadata": {},
    "name": "drawingSetVersionChangeStatusMutation",
    "operationKind": "mutation",
    "text": "mutation drawingSetVersionChangeStatusMutation(\n  $input: DrawingSetVersionChangeStatusInput!\n) {\n  drawingSetVersionChangeStatus(input: $input) {\n    ...drawingSetVersionFragment\n    id\n  }\n}\n\nfragment drawingSetVersionFragment on DrawingSetVersion {\n  id\n  createdAt\n  updatedAt\n  createdById\n  fileName\n  versionDate\n  status\n  drawingSetId\n  jobId\n}\n"
  }
};
})();

(node as any).hash = "5643e94ef8aa8ca878d80304ad11fa24";

export default node;
